'use client'
import React from 'react'
import { useTranslation } from '@/localization/useTranslation'

import classes from './styles.module.scss'

interface IErrorReferenceCodeProps {
  /** Renders nothing when absent — the line is reserved for errors that carry a code. */
  code?: number | null
}

/**
 * Small reference line shown under an error body, so a user can quote a code to
 * support for an error whose real cause is deliberately not disclosed in the UI
 * (reCAPTCHA rejections — see FZSPF-3835). The same code is on the Sentry event
 * and the Clarity session tag.
 */
export const ErrorReferenceCode: React.FC<IErrorReferenceCodeProps> = ({ code }) => {
  const { t } = useTranslation()

  if (!code) return null

  return (
    <p className={classes.reference}>
      {t('Reference code: {code}', { code: `FZ-${code}` })}
    </p>
  )
}
